<template >
  <div>
    <section class="banner"  id="banner">
      <v-layout column align-center justify-center>
        <div class="janeiro white--text mb-3 text-xs-center" style="margin: 0 !important; width: 400px;">FEVEREIRO DE 2026</div>
        <div class="encontro1 white--text mb-3 text-xs-center">V Encontro</div>
      </v-layout>
      <v-layout column align-center justify-center class="banner-bottom">
        <div class="familiacantu white--text mb-3 text-xs-center">Família Cantu</div>
        <div class="brasil white--text mb-3 text-xs-center">NO BRASIL</div>
        <img src="/static/img/Ativo 10@4x.png" alt="FAMILIA CANTU" width="460" height="30">
        <img src="/static/img/Ativo 12@4x.png" alt="FAMILIA CANTU" width="500" height="20">
        <img src="/static/img/Ativo 7@4x.png" alt="FAMILIA CANTU" width="500" height="25">
      </v-layout>
    </section>

    <section class="banner3" id="historia">
      <v-layout
        column
        wrap
        class="mt-5 ml-5 mr-5"
        align-center
      >
        <v-flex xs12 sm4 class="mt-3 ml-3 mr-3">
          <v-layout column align-center justify-center>
            <p class="como-funciona"> <span> Um pouco da </span></p>
            <div class="historia black--text text-xs-center">NOSSA HISTÓRIA</div>
            <v-layout wrap align-center>
              <v-flex xs12 sm6 offset-sm3>
                
                <v-card-text class="text-xs-center text-historia" v-html="model.card1">
                </v-card-text>
              </v-flex>
            </v-layout>
            <v-btn
              class="vejamais"
              href="/#/historia"
            >
              Veja mais
            </v-btn>
            <div class="banner-discendent hidden-xl-only text-xs-center">DISCENDENTI DI DOMENICO CANTÚ</div>
            <div class="banner-discendent2 hidden-lg-and-down text-xs-center">DISCENDENTI DI DOMENICO CANTÚ</div>
            
          </v-layout>
        </v-flex>
      </v-layout>
    </section>

    <section class="banner22 hidden-lg-and-down" id="encontro">
      <div class="encontro white--text text-xs-center">V ENCONTRO BIENAL FAMÍLIA CANTÚ</div>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-5" style="margin-bottom: 0px !important;margin-top: 0px !important;">
          <v-flex xs12 sm4 class="cardencontro" style="height: 410px;">
            <v-card class="elevation-0 text-xs-center" style="height: 410px;">
              <v-card-title primary-title class="layout justify-center" style="padding-top: 60px;">
                <div class="headlinencon2">Localização</div>
              </v-card-title>
              <v-card-text class="trajan-pro3" style="font-size: 18px;padding:0; margin-left:auto;margin-right:auto; width: 350px">
                SÃO MATEUS DO SUL - PR
              </v-card-text>
              <v-card-text class="trajan-pro3" style="font-size: 18px;padding:0; margin-left:auto;margin-right:auto; width: 350px">
                Samas Klub (Antigo CEPE) - Rua Manoel Cunha Bitencourt, 2100 - Vila Canoas
              </v-card-text>
              <v-card-text class="trajan-pro3" style="font-size: 18px;padding:0; margin-left:auto;margin-right:auto; width: 250px">
                15 de Fevereiro de 2026
              </v-card-text>
              <div class="layout justify-center" style="padding-top:10px;" >
                <img src="/static/img/Ativo 6@4x.png" alt="FAMILIA CANTU" height="10">
              </div>
              <v-card-title primary-title style="padding-bottom:0;" class="layout justify-center">
                <div class="headlinencon2">Informações</div>
              </v-card-title>
              <v-card-text class="trajan-pro3" style="font-size: 30px; padding:0; margin-left:auto;margin-right:auto; width: 200px">
                e contato
              </v-card-text>
              <!-- <v-layout row wrap >
                <v-flex xs6 sm6 style="padding:0;">
                  <v-card-text class="trajan-pro3" style="padding:0; margin-left:auto;margin-right:auto; width: 200px">
                    VALDECIR BORDIGNON
                  </v-card-text>
                  <v-card-text class="trajan-pro3" style="padding:0; margin-left:auto;margin-right:auto; width: 200px">
                    (49) 9 9981-5511
                  </v-card-text>
                </v-flex>
                <v-flex xs6 sm6 style="padding:0;">
                  <v-card-text class="trajan-pro3" style="padding:0; margin-left:auto;margin-right:auto; width: 200px">
                    MARISTELE BORDIGNON
                  </v-card-text>
                  <v-card-text class="trajan-pro3" style="padding:0; margin-left:auto;margin-right:auto; width: 200px">
                    (49) 9 9900-5966
                  </v-card-text>
                </v-flex>
              </v-layout> -->
              <v-card-text class="trajan-pro3" style="padding:0; margin-left:auto;margin-right:auto; width: 300px">
                contato@familiacantu.com.br
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 class="py-0">
            <v-card class="elevation-0 img-local2">
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm4 class="cardencontro" style="padding-top: 0px !important; height: 410px;">
            <v-card class="elevation-0 text-xs-center" style="height: 410px; background-color: #f9ba75">
              <v-card-text class="trajan-pro3" style="font-size: 20px;padding:0; padding-top:80px; margin-left:auto;margin-right:auto; width: 300px" >
                É com gratidão e alegria que, nós descendentes de Domeneco Cantú, convidamos a todos os familiares para o 5° Incontro da Família Cantú.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 class="cardencontro" style="padding-top: 0px !important;padding-left: 0px !important; height: 410px;">
            <v-card class="elevation-0 text-xs-center" style="height: 410px;">
              
              <v-card-text class="trajan-pro3" style="font-size: 30px; padding:0; padding-top:80px; margin-left:auto;margin-right:auto; width: 270px;">
                Programação 5ª FESTA ANUAL FAMÍLIA CANTÚ
              </v-card-text>
              
              <v-btn
                style="background-color:#f9ba75; width: 114px;border-radius: 30%;"
                href="/static/img/programacao-2026.pdf"
                target="_blank"
              >
                Confira
              </v-btn>
              
              <div class="layout justify-center" style="padding-top:10px;" >
                <img src="/static/img/Ativo 6@4x.png" alt="FAMILIA CANTU" height="10">
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section class="banner2 hidden-xl-only">
      <div class="encontro white--text text-xs-center">III ENCONTRO BIENAL FAMÍLIA CANTÚ</div>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-5" style="margin-bottom: 0px !important;margin-top: 0px !important;">
          <v-flex xs12>
            <v-img src="/static/img/programacao-2026.pdf" alt="Convite" class="img-fluid"></v-img>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <!-- <section>
      <v-container>
        <v-layout wrap align-center>
          <v-flex sm8 class="mx-auto" >
            <div class="text-xs-center">
              <div class="encontro black--text text-xs-center mb-3" style="font-size: 20px;">OPÇÕES DE ACOMODAÇÃO</div>
              <img src="/static/img/Ativo 6@4x.png" alt="FAMILIA CANTU" style="padding:0; margin-left:auto;margin-right:auto;" height="15">
            </div>           

            <v-layout wrap align-center>

              <v-flex xs12 sm6 class="mx-auto">
                  <div class="black--text acomodacao-item">
                    <strong>BELVEDERE HOTEL E POUSA</strong><br/>
                    R. MATO GROSSO, 180<br/>
                    EM ANCHIETA<br/>
                  </div>
              </v-flex>
              

              <v-flex xs12 sm6 class="mx-auto">
                  <div class="black--text acomodacao-item">
                    <strong>CIDADES DA REGIÃO</strong><br/>
                    SÃO MIGUEL DO OESTE, PALMA SOLA, CAMPO ÊRE, SÃO JOSÉ DO CEDRO<br/>
                  </div>
              </v-flex>
              
              <v-flex xs12 sm6 class="mx-auto">
                  <div class="black--text acomodacao-item">
                    <strong>Hotel Ville House Premium</strong><br/>
                    Rua Lopes Trovão, 20 - São Luís, Canoas – RS<br/>
                    2 km do local da festa<br/>  
                    <a href="http://www.hotelvillehouse.com.br/" target="_blank">
                      <v-btn color="btn-theme">Site Hotel</v-btn>
                    </a>
                    <a href="https://www.booking.com/hotel/br/ville-house-premium.pt-br.html" target="_blank">
                      <v-btn color="btn-theme">Reservar Booking</v-btn>
                    </a>
                  </div>
              </v-flex>
              
              <v-flex xs12 sm6 class="mx-auto">
                  <div class="black--text acomodacao-item">
                    <strong>Hotel Express Canoas</strong><br/>
                    Avenida Getúlio Vargas, 5075 - Centro, Canoas – RS<br/>
                    3 km do local da festa<br/>  
                    <a href="https://www.hotelexpress.tur.br/hx/hotel-express-canoas/#" target="_blank">
                      <v-btn color="btn-theme">Site Hotel</v-btn>
                    </a>
                    <a href="https://www.booking.com/hotel/br/express-canoas.pt-br.html" target="_blank">
                      <v-btn color="btn-theme">Reservar Booking</v-btn>
                    </a>
                  </div>
              </v-flex>
              
              <v-flex xs12 sm6 class="mx-auto">
                  <div class="black--text acomodacao-item">
                    <strong>Ibis Canoas Shopping</strong><br/>
                    Rua Mathias Velho, 235 - Centro, Canoas - RS<br/>
                    3 km do local da festa<br/>  
                    <a href="https://all.accor.com/hotel/8273/index.ptbr.shtml?dateIn=&nights=&compositions=1&stayplus=false&snu=false#origin=ibis" target="_blank">
                      <v-btn color="btn-theme">Site Hotel</v-btn>
                    </a>
                    <a href="https://www.booking.com/hotel/br/ibis-canoas-shopping.pt-br.html" target="_blank">
                      <v-btn color="btn-theme">Reservar Booking</v-btn>
                    </a>
                  </div>
              </v-flex>
              
              <v-flex xs12 sm6 class="mx-auto">
                  <div class="black--text acomodacao-item">
                    <strong>Canoas Parque Hotel</strong><br/>
                    Avenida Getúlio Vargas, 7421 - Igara, Canoas – RS<br/>
                    500 mt do local da festa<br/>  
                    <a href="https://www.canoasparquehotel.com.br/" target="_blank">
                      <v-btn color="btn-theme">Site Hotel</v-btn>
                    </a>
                    <a href="https://www.booking.com/hotel/br/canoas-parque.pt-br.html" target="_blank">
                      <v-btn color="btn-theme">Reservar Booking</v-btn>
                    </a>
                  </div>
              </v-flex>
              

            </v-layout>
          </v-flex>
        </v-layout>
        
      </v-container>
    </section>
     -->
  
    <v-container grid-list-xl>
      <v-layout row wrap justify-center class="my-5" style="margin-bottom: 0px !important;margin-top: 0px !important;">
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScvAobf976-dYJxwI6Sm4zl9wlYZ9AuPQUy_j4zSh-9aJaj9Q/viewform?embedded=true" width="640" height="573" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
      </v-layout>
    </v-container>

    
    <v-dialog v-model="dialogMensagem" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Parabéns</v-card-title>
        <v-card-text>Sua inscrição foi salva com sucesso. Se vemos no encontro!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="dialogMensagem = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import store from "../store";
import usuario from "@/services/usuario";
import parameter from "@/services/parameter";

export default {
  name: 'Home',
  mixins: [validationMixin],
  data () {
    return {
      msg: 'Home',
      email: '',
      data: {},
      password: '',
      dialogMensagem: false,
      model: {},
      cards: {
        card1: "",
        card2: "",
        card3: ""
      },
      items: [
        {text: "Lúcia Cantú / Beniamino Giovanni Baseggio", disabled: true},
        {text: "Amália Baseggio"},
        {text: "Marieta Baseggio"},
        {text: "Alberto Baseggio"},
        {text: "Ricardo Baseggio"},
        {text: "Laurindo Baseggio"},
        {text: "Primo Baseggio"},
        {text: "Albina Baseggio"},
        {text: "Angelo Baseggio"},
        {text: "João Baseggio"},
        {text: "Albino Baseggio"},
        {text: "Estevão Baseggio"},
        {text: "Ernesto Baseggio"},
        {text: "Teresa Baseggio"},
        {text: "Letícia Baseggio"},
        {text: "Giovanni Maria Cantú / Santa Barbieri", disabled: true},
        {text: "Ricieri José Cantú / Barbara Baioco"},
        {text: "Maria Cantú / Angelo Locatelli"},
        {text: "Guilherme Cantú / Maria Salvi"},
        {text: "Domingos Cantú / Carolina Salvi"},
        {text: "Victório Cantú"},
        {text: "Vergílio Domingos Cantú / Melânia Defendi"},
        {text: "Palmira Cantú / Luiz Salvi"},
        {text: "Valéria Maghia Cantú / Augusto Mariani"},
        {text: "Francisco Cantú / Davidica Pelissari"},
        {text: "Cezare Cantú / Santina Pavan"},
        {text: "Pietro Silvio Cantú / Santa Ferranti", disabled: true},
        {text: "José Vergílio Cantú / Ana Maria Rigo / Dileta Morelato"},
        {text: "Amante Cantú / Graciosa Noelo"},
        {text: "Cezare Cantú /"},
        {text: "João Domingos Cantú / Clélia Barichello"},
        {text: "Valentim Cantú / Filomena Dal Pizzol"},
        {text: "Linda Cantú / Isidoro Mamentini"},
        {text: "Luiz Cantú / Maria Reck / Helena Biscaro"},
        {text: "Valeria Cantú"},
        {text: "Angelina Cantú / Carlos DallAgnol"},
        {text: "Marieta Cantú / Vitório Guarda"},
        {text: "Convidados"}
      ]
    }
  },
  methods: {
    salvar: function() {
      console.log(this.data);
      parameter.saveContato(this.data).then(res => {
        console.log( res );
        if (res.data && res.data.error) {
          this.message = res.data.error.data;
          this.dialogError = true;
        } else {
          this.dialogMensagem = true;
        }
      });
    },
    async submit () {
      this.$v.$touch()
      await this.$store.dispatch('signUserIn', {username: this.email, password: this.password})
      await usuario.getUsuario(store.getters.user._id).then(async (res) => {
        if (res.grand == "User") {
          await this.$router.push('/descontos');
        } else {
          await this.$router.push('/admin-home');
        }
      });
    }
  }, 
  created() {
    parameter.getParameter().then(res => {
      if (res) {
        this.model = res;
        this.model.card1 = this.model.card1.replace(/(?:\r\n|\r|\n)/g, '<br>');
        this.model.card1 = this.model.card1.substring(0, 400) + '...'; 
      }
    });
  },
  watch: {
    user (value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/')
      }*/
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Deve ser um e-mail válido')
      !this.$v.email.required && errors.push('Usuário deve ser informado')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Senha deve ser informada')
      return errors
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner {
    background-image: url('/static/img/Ativo 14@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    max-height: 100%;
    height: 100% !important;
    min-height: 750px;
    width: 100%;
    padding-top: 120px;
    position:relative; 
  }
  .banner-bottom {
    width: 100%;
    position:absolute;                  
    bottom:0;   
  }
  .img-local {
    background-image: url('/static/img/Ativo 15@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    max-height: 100%;
    min-height: 350px;
    width: 100%;
  }
  .img-local2 {
    background-image: url('/static/img/banner-home-2026.jpg');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    max-height: 100%;
    min-height: 410px;
    width: 100%;
  }
  .banner2 {
    background-image: url('/static/img/Ativo 1@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    max-height: 100%;
    min-height: 700px;
    width: 100%;
    padding-top: 80px;
  }
  .banner22 {
    background-image: url('/static/img/Ativo 1@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    max-height: 100%;
    min-height: 1100px;
    width: 100%;
    padding-top: 80px;
  }
  .banner3 {
    position:relative; 
  }
  .input-login {
    background-color: white;
    border-radius: 10px;
    padding: 10px;
  }
  .janeiro {
    font-size: 25px;
    background: #c99d66;
    font-family: 'TrajanPro3-Regular', sans-serif !important;

  }
  .encontro1 {
    font-size: 50px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;

  }
  .encontro {
    font-size:3vw;
    font-family: 'TrajanPro3-Regular', sans-serif !important;

  }
  .brasil {
    font-size: 30px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historia {
    font-size: 22px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .familiacantu {
    height: 60px;
    widows: 220px;
    font-size: 60px;
    font-family: 'marguerite', sans-serif !important;
  }
  .py-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .text-historia {
    font-size:8px + 0.5vw;
    font-weight: 700;
  }
  .vejamais {
    background-color: #c99d66 !important;
    color: #333335;
    border-radius: 20%;
    text-transform: none;
    font-family: 'marguerite', sans-serif !important;
    margin-bottom: 100px;
  }
  .banner-discendent {
    width: 100%;
    position:absolute;   
    color: #dec4a3;     
    font-size:4.3vw;
    font-family: 'TrajanPro3-Regular', sans-serif !important;       
    bottom:0;   
    height: 60px;
  }
  .banner-discendent2 {
    width: 100%;
    position:absolute;   
    color: #dec4a3;   
    font-size: 80px;     
    font-family: 'TrajanPro3-Regular', sans-serif !important;       
    bottom:0;   
    height: 80px;
  }
  .cardencontro {
    margin-right: 0px; 
    padding-right: 0px !important; 
  }
  
  .trajan-pro3 {
    font-family: 'TrajanPro3-Regular', sans-serif !important; 
  }
  .headlinencon {

    font-size: 20px;
    font-family: 'marguerite', sans-serif !important;
  }
  .headlinencon2 {

    font-size: 30px;
    font-family: 'marguerite', sans-serif !important;
  }

  h1 {
    font-size: 40px !important;
    font-weight: 500;
  }
  h2 {
    font-weight: 500;
  }

  .v-card-title {
    font-weight: 600 !important;
    font-size: 35px !important;
  }

  .hr-title {
    border: none;
    border-top: 6px solid white;
    width: 150px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .como-funciona {
    line-height: 0.5;
    text-align: center;
    font-weight: 500;
    font-size: 30px;
    font-family: 'marguerite', sans-serif !important;
  }
  .como-funciona span {
    display: inline-block;
    position: relative;  
  }
  .como-funciona span:before,
  .como-funciona span:after {
    content: "";
    position: absolute;
    height: 5px;
    margin-top: 12px;
    border-image: url('/static/img/Ativo 11@4x.png') 30 round;
    border-bottom: 3px solid transparent;
    top: 0;
    width: 250px;
  }
  .como-funciona span:before {
    right: 100%;
    margin-right: 15%;
  }
  .como-funciona span:after {
    left: 100%;
    margin-left: 15%;
  }
  
  .acomodacao-item { text-align:center; margin-bottom:20px; }
  .acomodacao-item .btn-theme { background-color: rgb(249, 186, 117) !important; border-radius: 30%; }

  @media (max-width: 768px) {
    .banner {
      background-size: cover;
      background-position: center center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue